import { type StandardInitiatePaymentParams, isTripPayment } from "./types";

export const constructOrderApiParams = (
  params: StandardInitiatePaymentParams,
) => {
  if (isTripPayment(params)) {
    const { serviceType, ...rest } = params;

    return {
      apiUrl: "/orders/package",
      apiParams: rest,
    };
  } else {
    const { availabilityTokens } = params;

    return {
      apiUrl: "/orders",
      apiParams: {
        availabilityTokens,
      },
    };
  }
};
